import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IStatusPill } from 'types/ui/statusPill.interface'

export const SupplyCellValue = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const SupplyLeadWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const SupplyLeadDelta = styled.span<{ $tone: IStatusPill['status'] }>`
  font-size: ${tokens.font.label};
  color: ${({ $tone }) => tokens.status[$tone].fg};
  white-space: nowrap;
`

export const SupplyNoteText = styled.span<{ $tone: IStatusPill['status'] }>`
  font-size: ${tokens.font.label};
  color: ${({ $tone }) => tokens.status[$tone].fg};
`

export const SupplyOpenOrders = styled.span<{ $open?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${({ $open }) => ($open ? 600 : 400)};
  font-variant-numeric: tabular-nums;
  color: ${({ $open }) => ($open ? tokens.text.primary : tokens.text.secondary)};
`
